






































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';

@Component
export default class DlgMemberNew extends Vue {
  public $refs!: {
    form: any,
  };

  @Action('admin/moderators/create') private createModerator!: any;
  @Action('admin/moderators/read') private readModerators!: any;
  @Getter('common/rules/all') private rules!: any;

  private moderator: any = {};
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;

  private async save(e) {
    if (e) {
      e.preventDefault();
    }
    if (this.$refs.form.validate()) {
      this.loading = true;

      // Step 1: save moderator
      this.createModerator(this.moderator)
        .then((success: any) => {
          if (success) {
            return this.readModerators();
          }
          throw new Error();
        })
        .then(() => {
          this.loading = false;
          this.dialog = false;
          this.moderator = {};
          this.$refs.form.resetValidation();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }
}
